import script from "./CodePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CodePicker.vue?vue&type=script&setup=true&lang=js"

import "./CodePicker.vue?vue&type=style&index=0&id=71ea3c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ea3c60"]])

export default __exports__